import { PhoneTypeModel } from '../model/phone-type.model';

export interface PhoneTypeMap {
  [key: string]: PhoneTypeModel;
}

export const PhoneTypes: PhoneTypeModel[] = [
  new PhoneTypeModel({
    'pht_key': '52AB7C1D-FE7D-466B-95C0-B715D9649215',
    'pht_code': 'Mobile'
  }),
  new PhoneTypeModel({
    'pht_key': '3A4E6F64-9CD5-40A5-B04E-AD63882F16F3',
    'pht_code': 'Landline'
  })
];

export const PhoneTypeCodeMap: PhoneTypeMap = {
  'Mobile': PhoneTypes[0],
  'Landline': PhoneTypes[1]
};


export const PhoneTypeKeyMap: PhoneTypeMap = {
};

for (const type of PhoneTypes) {
  PhoneTypeKeyMap[type.pht_key.toUpperCase()] = type;
  PhoneTypeKeyMap[type.pht_key.toLowerCase()] = type;
}

